module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kb4so"))).then(() => parcelRequire('hEqeo'));